import { mc, StyleProps } from '@styles';
import { TestIdProps } from '@utils';
import React, { FC } from 'react';

import AppDownload from '../AppDownload';

type Props = StyleProps & TestIdProps;

export const AppDownloadSection: FC<Props> = ({ testId, style, className }) => {
  return (
    <div data-testid={testId} className={mc('bg-white', className)} id="app-download-footer" style={style}>
      <div className="bg-seafoam" style={{ borderTopLeftRadius: 40, borderTopRightRadius: 40 }}>
        <div className="container mx-auto px-4 md:px-8 pt-10 pb-12 lg:px-16 lg:pt-20 lg:pb-24 flex flex-col lg:flex-row justify-between">
          <div className="w-full lg:w-4/12">
            <h5 className="mt-0 mb-0 text-center md:text-left text-4xl lg:text-6xl">Download the CircleOf App for Free</h5>
          </div>
          <div className="w-full lg:w-7/12 mt-6 lg:mt-0">
            <AppDownload className="lg:ml-4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadSection;
